import { Data } from '@angular/router';

export function getTranslationValue(translation: Data, key: string): string {
  const value: unknown = translation[key];
  return typeof value === 'string' ? value : key;
}
